import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import UserManagement from './pages/UserManagement';


function App() {
  
  //      const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const navigate = useNavigate(); // This hook must be called inside a component wrapped by Router

  // useEffect(() => {
  //   const userID = localStorage.getItem('id');
  //   if (userID) {
  //     //setIsLoggedIn(true);
  //     navigate('dashboard'); // Redirect to dashboard if logged in
  //   } else {
  //     //setIsLoggedIn(false);
  //     navigate('login'); // Redirect to login if not logged in
  //   }
  // }, [navigate]);
  return (
<BrowserRouter>
    {/* <NavBar/> */}
    <div className='holder'>
    <Routes>
    <Route path="/" element={<Login />}/>
    <Route path="dashboard" element={<Dashboard />}/>
    <Route path="login" element={<Login />}/>
    <Route path="userManagement" element={<UserManagement />}/>
    </Routes>
    </div>
</BrowserRouter>
    );
}

export default App;
